import React, { useEffect, useMemo, useRef, useState } from 'react'

// =========================================================================
// TRADUCTOR VISUAL (Para los textos de Ganador en Pantalla)
// =========================================================================
const getVisualZoneName = (realZoneName) => {
    if (!realZoneName) return '';
    const normalized = realZoneName.toLowerCase().trim();

    const aliases = {
        'zona1': 'Santos Local',
        'zona 1': 'Santos Local',
        'santos local': 'Santos Local',
        'team santos local': 'Santos Local',
        'lucho': 'Santos Local',
        'team lucho': 'Santos Local',
        'player1': 'Santos Local',

        'zona2': 'Santos Visitante',
        'zona 2': 'Santos Visitante',
        'santos visitante': 'Santos Visitante',
        'team santos visitante': 'Santos Visitante',
        'tunita': 'Santos Visitante',
        'team tunita': 'Santos Visitante',
        'player2': 'Santos Visitante'
    };

    return aliases[normalized] || realZoneName;
};

const GoalScreenV2 = ({ currentMatchState }) => {
    const {
        phase = 'WAITING',
        elapsedMilliseconds = 0,
        totalDurationMilliseconds = 1,
        zonesProgress = [],
        winner = null
    } = currentMatchState || {};

    const [viewStage, setViewStage] = useState('RACING');
    const maxPositionsHistoryRef = useRef({});

    useEffect(() => {
        const currentPhase = phase.toUpperCase();

        if (currentPhase === 'WAITING' || currentPhase === 'IDLE') {
            maxPositionsHistoryRef.current = {};

        } else if (currentPhase === 'RUNNING') {
            setViewStage('RACING');

        } else if (currentPhase === 'FINISHED') {
            const isSingleWinner = winner && winner !== 'tie' && !winner.startsWith('tie_partial:');

            if (isSingleWinner) {
                setViewStage('KICK_ANIMATION');
                setTimeout(() => {
                    setViewStage('WINNER_TEXT');
                }, 2000);
            } else {
                setViewStage('WINNER_TEXT');
            }
        }
    }, [phase, winner]);

    // Ordena los jugadores una sola vez de acuerdo a su ID para fijar los carriles
    const dynamicZonesToRender = useMemo(() => {
        if (!zonesProgress || zonesProgress.length === 0) return [];
        return [...zonesProgress].sort((a, b) => {
             const zoneA = a.zoneIdentifier || `unknown`;
             const zoneB = b.zoneIdentifier || `unknown`;
             return zoneA.localeCompare(zoneB);
        });
    }, [zonesProgress]);

    const timeCompletedPercentage = useMemo(() => {
        if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') return 0;
        const percentage = (elapsedMilliseconds / totalDurationMilliseconds) * 100;
        return Math.min(100, Math.max(0, percentage));
    }, [elapsedMilliseconds, totalDurationMilliseconds, phase]);

    //const highestTapsOverall = dynamicZonesToRender[0]?.totalTaps || 0;
    // 1. Calculamos al VERDADERO líder de la carrera (Buscando el número máximo)
    const highestTapsOverall = useMemo(() => {
        if (!zonesProgress || zonesProgress.length === 0) return 0;
        return Math.max(...zonesProgress.map(z => z.totalTaps || 0));
    }, [zonesProgress]);

    const MAXIMUM_VISUAL_LAG_PERCENTAGE = 25; // Máximo rezago visual (25%)

    // Normal
    const ZONES_SKINS = {
        'zona1': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'zona2': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'santos local': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'santos visitante': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'laboratorio tequis': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'canels': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'seguros el potosi': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'nissan': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'lounge ron potosi': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'azul': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
        'red cola': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'tecate': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'moctezuma': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'mobil': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'oro': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
        'default': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' }
    };

    // Daikin
    // const ZONES_SKINS = {
    //     'laboratorio tequis': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
    //     'canels': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
    //     'seguros el potosi': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
    //     'nissan': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
    //     'lounge ron potosi': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
    //     'azul': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
    //     'red cola': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
    //     'tecate': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
    //     'moctezuma': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
    //     'mobil': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
    //     'oro': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
    //     'default': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' }
    // };

    const renderWinnerTextScreen = (winnerRaw) => {
        if (winnerRaw === 'tie') return '¡ES UN EMPATE!';
        if (winnerRaw.startsWith('tie_partial:')) {
            const tiedZones = winnerRaw.split(':')[1].split(' y ');
            const uniqueAliases = [...new Set(tiedZones.map(z => getVisualZoneName(z).toUpperCase()))];
            return `¡HAN EMPATADO ${uniqueAliases.join(' Y ')}!`;
        }
        // return `¡GOOOOOL DE ${getVisualZoneName(winnerRaw).toUpperCase()}!`;
        return `¡${getVisualZoneName(winnerRaw).toUpperCase()} HA ENCESTADO!`;
    };

    return (
        <>
            <div className='GoalScreenX__Sponsor' style={{ backgroundColor: '#fff', borderRadius: '8px', opacity: '0.8', padding: '6px', marginTop: '12px' }}>
                <img src="/img/page/adsl-five-bicolor.png" className='GoalScreenX__Sponsor__Image' style={{ width: '100%', maxWidth: '350px' }} alt="Sponsor" />
            </div>

            <div className="goal">
                <div className="goal__pitch Goal__V2__Background"></div>

                <div className="goal__lanes" style={{ gridTemplateRows: `repeat(${dynamicZonesToRender.length}, 1fr)` }}>
                    {dynamicZonesToRender.map((zoneItem, index) => {
                        const zoneId = zoneItem.zoneIdentifier || `unknown-${index}`;
                        
                        // // 1. CÁLCULO ESTRICTO (Sin Wobble)
                        // let finalPosition = timeCompletedPercentage;

                        // if (highestTapsOverall > 0) {
                        //     const userTaps = zoneItem.totalTaps || 0;
                        //     // Sacamos el porcentaje de rendimiento respecto al líder
                        //     const tapRatio = userTaps / highestTapsOverall; 
                            
                        //     // La posición es el reloj multiplicado por su rendimiento (Líder = 100%, Perdedor = 80%, etc.)
                        //     finalPosition = timeCompletedPercentage * tapRatio;

                        //     // Piso para que no desaparezcan de la pantalla si van perdiendo por mucho
                        //     const minPosition = timeCompletedPercentage - MAXIMUM_VISUAL_LAG_PERCENTAGE;
                        //     if (finalPosition < minPosition) finalPosition = minPosition;
                        // }

                        // 2. MATEMÁTICA CORREGIDA (Avance suave basado en el líder real)
                        let finalPosition = timeCompletedPercentage;

                        if (highestTapsOverall > 0) {
                            const tapsDeficit = highestTapsOverall - (zoneItem.totalTaps || 0);
                            const lagRatio = tapsDeficit / highestTapsOverall;
                            // El líder va con el reloj (0 deficit). El que va perdiendo se retrasa visualmente.
                            finalPosition -= (lagRatio * MAXIMUM_VISUAL_LAG_PERCENTAGE);
                        }

                        // // 2. EVITAR QUE CAMINEN PARA ATRÁS
                        // if (phase.toUpperCase() === 'RUNNING') {
                        //     const previousMaxPosition = maxPositionsHistoryRef.current[zoneId] || 0;
                        //     if (finalPosition < previousMaxPosition) {
                        //         // Si la matemática dice que van para atrás (porque el líder aceleró), simplemente los "congelamos" hasta que alcancen
                        //         finalPosition = previousMaxPosition;
                        //     } else {
                        //         maxPositionsHistoryRef.current[zoneId] = finalPosition;
                        //     }
                        // } else if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') {
                        //     finalPosition = 0;
                        // }

                        // 3. EVITAR QUE CAMINEN PARA ATRÁS
                        if (phase.toUpperCase() === 'RUNNING') {
                            const previousMaxPosition = maxPositionsHistoryRef.current[zoneId] || 0;
                            if (finalPosition < previousMaxPosition) {
                                finalPosition = previousMaxPosition;
                            } else {
                                maxPositionsHistoryRef.current[zoneId] = finalPosition;
                            }
                        } else if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') {
                            finalPosition = 0;
                        }

                        finalPosition = Math.min(100, Math.max(0, finalPosition));
                        const safeZoneId = (zoneId || '').trim().toLowerCase();
                        const skin = ZONES_SKINS[safeZoneId] || ZONES_SKINS["default"];

                        // 3. CORRECCIÓN DE PERSPECTIVA DE LA CANCHA
                        // Empujamos cada carril hacia la derecha dependiendo de su índice (carril de abajo se empuja más)
                        // Ajusta este "6" si sientes que le falta o le sobra inclinación
                        //const perspectiveOffset = index * 11; 

                        // Ajuste de Perspectiva: Mueve SOLO LA META. 
                        // El carril superior frena a 20vw del borde. El inferior frena a 14vw (para igualar la portería inclinada).
                        // Al estar en 0%, ambos arrancan desde la misma línea exacta.
                        const finishGap = 20 - (index * 6);

                        return (
                            // Aplicamos el transform translateX aquí para alinear la meta de ambos
                            // <div key={zoneId} className="goal__lane" style={{ transform: `translateX(${perspectiveOffset}vw)` }}>
                            <div key={zoneId} className="goal__lane" style={{ '--finish-gap': `${finishGap}vw` }}>
                                <div className="goal__runner" style={{ '--pct': finalPosition / 100 }}>
                                    <img className="goal__velocity" src={skin.spark} alt="destellos" />
                                    <img className="goal__avatar" src={skin.avatar} alt="Jugador" />
                                    <div className={`goal__ball__container ${phase.toUpperCase() === 'RUNNING' ? 'goal__ball__container--dribbling' : ''}`}>
                                        <div className="goal__ball__container__shadow" />
                                        <img className={`goal__ball__container__ball ${phase.toUpperCase() === 'RUNNING' ? 'goal__ball__container__ball--dribbling' : ''}`} src="/img/games/runtogoal/balon.png" alt="Balón" />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {viewStage === 'KICK_ANIMATION' && (
                    <div className="goal-outro">
                        <img src="/img/games/runtogoal/balon-grande.png" className="goal-outro__ball" alt="Balón" />
                    </div>
                )}

                {viewStage === 'WINNER_TEXT' && (
                    <div className="goal__pov">
                        {winner ? (
                            <div className="goal__povGoool text-center">
                                {renderWinnerTextScreen(winner)}
                            </div>
                        ) : (
                            // <div className="goal__povGoool text-center">¡GOOOOOL!</div>
                            <div className="goal__povGoool text-center">¡VICTORIA!</div>
                        )}
                        <div className="goal__fw">
                            <div className="goal__fwBurst" />
                            <div className="goal__fwBurst goal__fwBurst--b2" />
                            <div className="goal__fwBurst goal__fwBurst--b3" />
                        </div>
                    </div>
                )}
            </div>

            <footer className='goal__footer'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</p>
            </footer>
        </>
    );
};

export { GoalScreenV2 };









// Funcional
// import React, { useEffect, useMemo, useRef, useState } from 'react'

// // =========================================================================
// // TRADUCTOR VISUAL (Para los textos de Ganador en Pantalla)
// // =========================================================================
// const getVisualZoneName = (realZoneName) => {
//     if (!realZoneName) return '';
//     const normalized = realZoneName.toLowerCase().trim();

//     // Daikin
//     const aliases = {
//         'laboratorio tequis': 'Pichon-kun', 'canels': 'Pichon-kun', 'seguros el potosi': 'Pichon-kun', 'nissan': 'Pichon-kun', 'lounge ron potosi': 'Pichon-kun', 'azul': 'Pichon-kun',
//         'red cola': 'Tunita', 'tecate': 'Tunita', 'moctezuma': 'Tunita', 'mobil': 'Tunita', 'oro': 'Tunita'
//     };
//     return aliases[normalized] || realZoneName;
// };

// const GoalScreenV2 = ({ currentMatchState }) => {
//     const {
//         phase = 'WAITING',
//         elapsedMilliseconds = 0,
//         totalDurationMilliseconds = 1,
//         zonesProgress = [],
//         winner = null
//     } = currentMatchState || {};

//     const [viewStage, setViewStage] = useState('RACING');
//     const maxPositionsHistoryRef = useRef({});

//     useEffect(() => {
//         const currentPhase = phase.toUpperCase();

//         if (currentPhase === 'WAITING' || currentPhase === 'IDLE') {
//             maxPositionsHistoryRef.current = {};

//         } else if (currentPhase === 'RUNNING') {
//             setViewStage('RACING');

//         } else if (currentPhase === 'FINISHED') {
//             const isSingleWinner = winner && winner !== 'tie' && !winner.startsWith('tie_partial:');

//             if (isSingleWinner) {
//                 setViewStage('KICK_ANIMATION');
//                 setTimeout(() => {
//                     setViewStage('WINNER_TEXT');
//                 }, 2000);
//             } else {
//                 setViewStage('WINNER_TEXT');
//             }
//         }
//     }, [phase, winner]);

//     // Ordena los jugadores una sola vez de acuerdo a su ID para fijar los carriles
//     const dynamicZonesToRender = useMemo(() => {
//         if (!zonesProgress || zonesProgress.length === 0) return [];
//         return [...zonesProgress].sort((a, b) => {
//              const zoneA = a.zoneIdentifier || `unknown`;
//              const zoneB = b.zoneIdentifier || `unknown`;
//              return zoneA.localeCompare(zoneB);
//         });
//     }, [zonesProgress]);

//     const timeCompletedPercentage = useMemo(() => {
//         if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') return 0;
//         const percentage = (elapsedMilliseconds / totalDurationMilliseconds) * 100;
//         return Math.min(100, Math.max(0, percentage));
//     }, [elapsedMilliseconds, totalDurationMilliseconds, phase]);

//     //const highestTapsOverall = dynamicZonesToRender[0]?.totalTaps || 0;
//     // 1. Calculamos al VERDADERO líder de la carrera (Buscando el número máximo)
//     const highestTapsOverall = useMemo(() => {
//         if (!zonesProgress || zonesProgress.length === 0) return 0;
//         return Math.max(...zonesProgress.map(z => z.totalTaps || 0));
//     }, [zonesProgress]);

//     const MAXIMUM_VISUAL_LAG_PERCENTAGE = 25; // Máximo rezago visual (25%)

//     // Daikin
//     const ZONES_SKINS = {
//         'laboratorio tequis': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'canels': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'seguros el potosi': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'nissan': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'lounge ron potosi': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'azul': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'red cola': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'tecate': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'moctezuma': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'mobil': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'oro': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'default': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' }
//     };

//     const renderWinnerTextScreen = (winnerRaw) => {
//         if (winnerRaw === 'tie') return '¡ES UN EMPATE!';
//         if (winnerRaw.startsWith('tie_partial:')) {
//             const tiedZones = winnerRaw.split(':')[1].split(' y ');
//             const uniqueAliases = [...new Set(tiedZones.map(z => getVisualZoneName(z).toUpperCase()))];
//             return `¡HAN EMPATADO ${uniqueAliases.join(' Y ')}!`;
//         }
//         return `¡GOOOOOL DE ${getVisualZoneName(winnerRaw).toUpperCase()}!`;
//     };

//     return (
//         <>
//             <div className='GoalScreenX__Sponsor' style={{ backgroundColor: '#fff', borderRadius: '8px', opacity: '0.8', padding: '6px', marginTop: '12px' }}>
//                 <img src="/img/page/adsl-five-bicolor.png" className='GoalScreenX__Sponsor__Image' style={{ width: '100%', maxWidth: '350px' }} alt="Sponsor" />
//             </div>

//             <div className="goal">
//                 <div className="goal__pitch Goal__V2__Background"></div>

//                 <div className="goal__lanes" style={{ gridTemplateRows: `repeat(${dynamicZonesToRender.length}, 1fr)` }}>
//                     {dynamicZonesToRender.map((zoneItem, index) => {
//                         const zoneId = zoneItem.zoneIdentifier || `unknown-${index}`;
                        
//                         // // 1. CÁLCULO ESTRICTO (Sin Wobble)
//                         // let finalPosition = timeCompletedPercentage;

//                         // if (highestTapsOverall > 0) {
//                         //     const userTaps = zoneItem.totalTaps || 0;
//                         //     // Sacamos el porcentaje de rendimiento respecto al líder
//                         //     const tapRatio = userTaps / highestTapsOverall; 
                            
//                         //     // La posición es el reloj multiplicado por su rendimiento (Líder = 100%, Perdedor = 80%, etc.)
//                         //     finalPosition = timeCompletedPercentage * tapRatio;

//                         //     // Piso para que no desaparezcan de la pantalla si van perdiendo por mucho
//                         //     const minPosition = timeCompletedPercentage - MAXIMUM_VISUAL_LAG_PERCENTAGE;
//                         //     if (finalPosition < minPosition) finalPosition = minPosition;
//                         // }

//                         // 2. MATEMÁTICA CORREGIDA (Avance suave basado en el líder real)
//                         let finalPosition = timeCompletedPercentage;

//                         if (highestTapsOverall > 0) {
//                             const tapsDeficit = highestTapsOverall - (zoneItem.totalTaps || 0);
//                             const lagRatio = tapsDeficit / highestTapsOverall;
//                             // El líder va con el reloj (0 deficit). El que va perdiendo se retrasa visualmente.
//                             finalPosition -= (lagRatio * MAXIMUM_VISUAL_LAG_PERCENTAGE);
//                         }

//                         // // 2. EVITAR QUE CAMINEN PARA ATRÁS
//                         // if (phase.toUpperCase() === 'RUNNING') {
//                         //     const previousMaxPosition = maxPositionsHistoryRef.current[zoneId] || 0;
//                         //     if (finalPosition < previousMaxPosition) {
//                         //         // Si la matemática dice que van para atrás (porque el líder aceleró), simplemente los "congelamos" hasta que alcancen
//                         //         finalPosition = previousMaxPosition;
//                         //     } else {
//                         //         maxPositionsHistoryRef.current[zoneId] = finalPosition;
//                         //     }
//                         // } else if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') {
//                         //     finalPosition = 0;
//                         // }

//                         // 3. EVITAR QUE CAMINEN PARA ATRÁS
//                         if (phase.toUpperCase() === 'RUNNING') {
//                             const previousMaxPosition = maxPositionsHistoryRef.current[zoneId] || 0;
//                             if (finalPosition < previousMaxPosition) {
//                                 finalPosition = previousMaxPosition;
//                             } else {
//                                 maxPositionsHistoryRef.current[zoneId] = finalPosition;
//                             }
//                         } else if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') {
//                             finalPosition = 0;
//                         }

//                         finalPosition = Math.min(100, Math.max(0, finalPosition));
//                         const safeZoneId = (zoneId || '').trim().toLowerCase();
//                         const skin = ZONES_SKINS[safeZoneId] || ZONES_SKINS["default"];

//                         // 3. CORRECCIÓN DE PERSPECTIVA DE LA CANCHA
//                         // Empujamos cada carril hacia la derecha dependiendo de su índice (carril de abajo se empuja más)
//                         // Ajusta este "6" si sientes que le falta o le sobra inclinación
//                         const perspectiveOffset = index * 11; 

//                         return (
//                             // Aplicamos el transform translateX aquí para alinear la meta de ambos
//                             <div key={zoneId} className="goal__lane" style={{ transform: `translateX(${perspectiveOffset}vw)` }}>
//                                 <div className="goal__runner" style={{ '--pct': finalPosition / 100 }}>
//                                     <img className="goal__velocity" src={skin.spark} alt="destellos" />
//                                     <img className="goal__avatar" src={skin.avatar} alt="Jugador" />
//                                     <div className='goal__ball__container'>
//                                         <img className="goal__ball__container__ball" src="/img/games/runtogoal/balon.png" alt="Balón" />
//                                     </div>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>

//                 {viewStage === 'KICK_ANIMATION' && (
//                     <div className="goal-outro">
//                         <img src="/img/games/runtogoal/balon-grande.png" className="goal-outro__ball" alt="Balón" />
//                     </div>
//                 )}

//                 {viewStage === 'WINNER_TEXT' && (
//                     <div className="goal__pov">
//                         {winner ? (
//                             <div className="goal__povGoool text-center">
//                                 {renderWinnerTextScreen(winner)}
//                             </div>
//                         ) : (
//                             <div className="goal__povGoool text-center">¡GOOOOOL!</div>
//                         )}
//                         <div className="goal__fw">
//                             <div className="goal__fwBurst" />
//                             <div className="goal__fwBurst goal__fwBurst--b2" />
//                             <div className="goal__fwBurst goal__fwBurst--b3" />
//                         </div>
//                     </div>
//                 )}
//             </div>

//             <footer className='goal__footer'>
//                 <p className='text-center FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</p>
//             </footer>
//         </>
//     );
// };

// export { GoalScreenV2 };









// import React, { useEffect, useMemo, useRef, useState } from 'react'

// // =========================================================================
// // TRADUCTOR VISUAL (Para los textos de Ganador en Pantalla)
// // =========================================================================
// const getVisualZoneName = (realZoneName) => {
//     if (!realZoneName) return '';
//     const normalized = realZoneName.toLowerCase().trim();

//     // Normal
//     // const aliases = {
//     //     'laboratorio tequis': 'Lucho', 'canels': 'Lucho', 'seguros el potosi': 'Lucho', 'nissan': 'Lucho', 'lounge ron potosi': 'Lucho', 'azul': 'Lucho',
//     //     'red cola': 'Tunita', 'tecate': 'Tunita', 'moctezuma': 'Tunita', 'mobil': 'Tunita', 'oro': 'Tunita'
//     // };

//     // Daikin
//     const aliases = {
//         'laboratorio tequis': 'Pichon-kun', 'canels': 'Pichon-kun', 'seguros el potosi': 'Pichon-kun', 'nissan': 'Pichon-kun', 'lounge ron potosi': 'Pichon-kun', 'azul': 'Pichon-kun',
//         'red cola': 'Tunita', 'tecate': 'Tunita', 'moctezuma': 'Tunita', 'mobil': 'Tunita', 'oro': 'Tunita'
//     };
//     return aliases[normalized] || realZoneName;
// };

// const GoalScreenV2 = ({ currentMatchState }) => {
//     const {
//         phase = 'WAITING',
//         elapsedMilliseconds = 0,
//         totalDurationMilliseconds = 1,
//         zonesProgress = [],
//         winner = null
//     } = currentMatchState || {};

//     const [viewStage, setViewStage] = useState('RACING');
//     const maxPositionsHistoryRef = useRef({});

//     useEffect(() => {
//         const currentPhase = phase.toUpperCase();

//         if (currentPhase === 'WAITING' || currentPhase === 'IDLE') {
//             maxPositionsHistoryRef.current = {};

//         } else if (currentPhase === 'RUNNING') {
//             setViewStage('RACING');

//         } else if (currentPhase === 'FINISHED') {
//             const isSingleWinner = winner && winner !== 'tie' && !winner.startsWith('tie_partial:');

//             if (isSingleWinner) {
//                 setViewStage('KICK_ANIMATION');
//                 setTimeout(() => {
//                     setViewStage('WINNER_TEXT');
//                 }, 2000);
//             } else {
//                 setViewStage('WINNER_TEXT');
//             }
//         }
//     }, [phase, winner]);

//     // Mueve el ganador a la primera fila
//     // const dynamicZonesToRender = useMemo(() => {
//     //     if (!zonesProgress || zonesProgress.length === 0) return [];
//     //     return [...zonesProgress].sort((a, b) => (b.totalTaps || 0) - (a.totalTaps || 0));
//     // }, [zonesProgress]);

//     // Ordena los jugadores una sola vez de acuerdo a su ID
//     const dynamicZonesToRender = useMemo(() => {
//         if (!zonesProgress || zonesProgress.length === 0) return [];
//         // Ordenamos alfabéticamente por el identificador de zona para mantenerlos siempre en el mismo carril
//         return [...zonesProgress].sort((a, b) => {
//              const zoneA = a.zoneIdentifier || `unknown`;
//              const zoneB = b.zoneIdentifier || `unknown`;
//              return zoneA.localeCompare(zoneB);
//         });
//     }, [zonesProgress]);

//     const timeCompletedPercentage = useMemo(() => {
//         if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') return 0;
//         const percentage = (elapsedMilliseconds / totalDurationMilliseconds) * 100;
//         return Math.min(100, Math.max(0, percentage));
//     }, [elapsedMilliseconds, totalDurationMilliseconds, phase]);

//     const highestTapsOverall = dynamicZonesToRender[0]?.totalTaps || 0;
//     const MAXIMUM_VISUAL_LAG_PERCENTAGE = 25;

//     // La Moderna
//     // 'laboratorio tequis': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'canels': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'seguros el potosi': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'nissan': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'lounge ron potosi': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'azul': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'red cola': { avatar: '/img/games/runtogoal/la-moderna/spaghetti-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'tecate': { avatar: '/img/games/runtogoal/la-moderna/spaghetti-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'moctezuma': { avatar: '/img/games/runtogoal/la-moderna/spaghetti-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'mobil': { avatar: '/img/games/runtogoal/la-moderna/spaghetti-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'oro': { avatar: '/img/games/runtogoal/la-moderna/spaghetti-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' },
//     // 'default': { avatar: '/img/games/runtogoal/la-moderna/codito-la-moderna-five-digital-minds.png', spark: '/img/games/runtogoal/la-moderna/destellos-amarillos.png' }
    
//     // Normal
//     // const ZONES_SKINS = {
//     //     'laboratorio tequis': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
//     //     'canels': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
//     //     'seguros el potosi': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
//     //     'nissan': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
//     //     'lounge ron potosi': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
//     //     'azul': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' },
//     //     'red cola': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//     //     'tecate': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//     //     'moctezuma': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//     //     'mobil': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//     //     'oro': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//     //     'default': { avatar: '/img/games/runtogoal/luchito-caricatura.png', spark: '/img/games/runtogoal/destellos-rojos.png' }
//     // };

//     // Daikin
//     const ZONES_SKINS = {
//         'laboratorio tequis': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'canels': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'seguros el potosi': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'nissan': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'lounge ron potosi': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'azul': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' },
//         'red cola': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'tecate': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'moctezuma': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'mobil': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'oro': { avatar: '/img/games/runtogoal/tunita-caricatura.png', spark: '/img/games/runtogoal/destellos-azules.png' },
//         'default': { avatar: '/img/games/runtogoal/daikin/pichon-daikin-five-digital-minds.png', spark: '/img/games/runtogoal/daikin/destellos-azules.png' }
//     };

//     const WINNER_BACK_SKINS = {
//         'default': '' //'/img/games/runtogoal/la-moderna/personaje.png'
//     };

//     const safeWinnerId = (winner || '').trim().toLowerCase();
//     const winnerBackImage = WINNER_BACK_SKINS[safeWinnerId] || WINNER_BACK_SKINS["default"];

//     // Función segura para armar el texto del ganador evitando "Codito y Codito"
//     const renderWinnerTextScreen = (winnerRaw) => {
//         if (winnerRaw === 'tie') return '¡ES UN EMPATE!';

//         if (winnerRaw.startsWith('tie_partial:')) {
//             const tiedZones = winnerRaw.split(':')[1].split(' y ');
//             const uniqueAliases = [...new Set(tiedZones.map(z => getVisualZoneName(z).toUpperCase()))];
//             return `¡HAN EMPATADO ${uniqueAliases.join(' Y ')}!`;
//         }

//         // return `¡GOOOOOL DE ZONA ${getVisualZoneName(winnerRaw).toUpperCase()}!`;
//         return `¡GOOOOOL DE ${getVisualZoneName(winnerRaw).toUpperCase()}!`;
//     };

//     return (
//         <>
//             <div className='GoalScreenX__Sponsor' style={{ backgroundColor: '#fff', borderRadius: '8px', opacity: '0.8', padding: '6px', marginTop: '12px' }}>
//                 <img src="/img/page/adsl-five-bicolor.png" className='GoalScreenX__Sponsor__Image' style={{ width: '100%', maxWidth: '350px' }} alt="Sponsor" />
//             </div>

//             <div className="goal">
//                 <div className="goal__pitch Goal__V2__Background"></div>

//                 <div className="goal__lanes" style={{ gridTemplateRows: `repeat(${dynamicZonesToRender.length}, 1fr)` }}>
//                     {/* <div className="goal__penaltyMark" /> */}

//                     {dynamicZonesToRender.map((zoneItem, index) => {
//                         const zoneId = zoneItem.zoneIdentifier || `unknown-${index}`;
//                         let basePosition = timeCompletedPercentage;

//                         if (highestTapsOverall > 0) {
//                             const tapsDeficit = highestTapsOverall - (zoneItem.totalTaps || 0);
//                             const lagRatio = tapsDeficit / highestTapsOverall;
//                             basePosition -= (lagRatio * MAXIMUM_VISUAL_LAG_PERCENTAGE);
//                         }

//                         if (phase.toUpperCase() === 'RUNNING') {
//                             const wobbleNoise = Math.sin((elapsedMilliseconds / 300) + (index * 2)) * 1.5;
//                             basePosition += wobbleNoise;
//                         }

//                         let finalPosition = basePosition;
//                         if (phase.toUpperCase() === 'RUNNING') {
//                             const previousMaxPosition = maxPositionsHistoryRef.current[zoneId] || 0;
//                             if (finalPosition < previousMaxPosition) {
//                                 finalPosition = Math.min(previousMaxPosition + 0.05, timeCompletedPercentage);
//                             }
//                             maxPositionsHistoryRef.current[zoneId] = finalPosition;
//                         } else if (phase.toUpperCase() === 'WAITING' || phase.toUpperCase() === 'IDLE') {
//                             finalPosition = 0;
//                         }

//                         finalPosition = Math.min(100, Math.max(0, finalPosition));
//                         const safeZoneId = (zoneId || '').trim().toLowerCase();
//                         const skin = ZONES_SKINS[safeZoneId] || ZONES_SKINS["default"];

//                         return (
//                             <div key={zoneId} className="goal__lane">
//                                 <div className="goal__runner" style={{ '--pct': finalPosition / 100 }}>
//                                     <img className="goal__velocity" src={skin.spark} alt="destellos" />
//                                     <img className="goal__avatar" src={skin.avatar} alt="Jugador" />
//                                     <div className='goal__ball__container'>
//                                         <img className="goal__ball__container__ball" src="/img/games/runtogoal/balon.png" alt="Balón" />
//                                     </div>
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>

//                 {viewStage === 'KICK_ANIMATION' && (
//                     <div className="goal-outro">
//                         <img src="/img/games/runtogoal/balon-grande.png" className="goal-outro__ball" alt="Balón" />
//                         {/* <img src={winnerBackImage} className="goal-outro__player" alt="Jugador Ganador" /> */}
//                     </div>
//                 )}

//                 {viewStage === 'WINNER_TEXT' && (
//                     <div className="goal__pov">
//                         {winner ? (
//                             <div className="goal__povGoool text-center">
//                                 {/* APLICAMOS LA MÁSCARA AL RESULTADO FINAL */}
//                                 {renderWinnerTextScreen(winner)}
//                             </div>
//                         ) : (
//                             <div className="goal__povGoool text-center">¡GOOOOOL!</div>
//                         )}

//                         <div className="goal__fw">
//                             <div className="goal__fwBurst" />
//                             <div className="goal__fwBurst goal__fwBurst--b2" />
//                             <div className="goal__fwBurst goal__fwBurst--b3" />
//                         </div>
//                     </div>
//                 )}
//             </div>

//             <footer className='goal__footer'>
//                 <p className='text-center FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</p>
//             </footer>
//         </>
//     );
// };

// export { GoalScreenV2 };